export default __webpack_public_path__ + "static/icon-10-4-96b33eb607c70d0b61a28f41d928b074.png";